import { useQuery } from "@tanstack/react-query";
import { api, call, xClient } from "@/api/spec";
import { platform } from "@/platform";

export const storeRegionKey = ["store", "region"] as const;

/**
 * GET /store/region (상점·결제 설계 결정 16·17). 웹 상점이 계정 국가·결제 가능 여부를 알기 위해 쓴다 — 앱은 스토어가 판단하므로 호출하지 않는다.
 * 첫 호출이 계정 국가를 접속 국가로 확정하므로 상점 진입마다 fresh 로 둔다(staleTime 0).
 */
export function useStoreRegion(enabled = platform.clientKind === "web") {
  return useQuery({
    queryKey: storeRegionKey,
    enabled,
    queryFn: () => call(api.GET("/store/region", { params: { header: xClient() } })),
  });
}
